import { isUndefined } from 'lodash'

import { AdditionalFilterRecord } from '../types'

export const checkIfDateRangeValue = (
  value?: AdditionalFilterRecord[string],
): value is { from: number; to: number } => {
  return (
    typeof value === 'object' &&
    'to' in value &&
    'from' in value &&
    !isUndefined(value.to) &&
    !isUndefined(value.from)
  )
}
